import {Box, Card, Grid, Typography} from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainLayout from '../layouts/MainLayout';
import {Assessment} from "@mui/icons-material";
import { DpeStats } from '../interfaces/DpeStats';
import { getDpeStats } from '../services/dpeService';

const Home: React.FC = () => {
    const [stats, setStats] = useState<DpeStats | null>(null);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const data = await getDpeStats();
                setStats(data);
            } catch (error: any) {
                console.log(error);
            }
        };

        fetchStats();
    }, []);

    return (
        <MainLayout>
        <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm p-6">
                <h1 className="text-2xl font-semibold text-emerald-800 mb-4">
                    Tableau de bord
                </h1>
                <p className="text-emerald-600">
                    Bienvenue sur votre espace de gestion Wattless
                </p>
                {/*
                <Typography variant="body1" className="text-emerald-600">
                    Surveillez et optimisez votre consommation d'énergie
                </Typography>
                */}
            </div>

            {/* Cartes statistiques
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                {stats.map((stat, index) => (
                    <div key={index} className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between">
                            <div>
                                <p className="text-emerald-600 text-sm font-medium mb-1">{stat.title}</p>
                                <h3 className="text-2xl font-bold text-emerald-800 mb-2">{stat.value}</h3>
                                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-sm ${
                                    stat.change.startsWith('+') ? 'bg-green-100 text-green-800' : 'bg-emerald-100 text-emerald-800'
                                }`}>
                                    {stat.change}
                                </span>
                            </div>
                            <div className="bg-emerald-100 p-3 rounded-lg">
                                <span className="material-icons text-emerald-600">{stat.icon}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
*/}

            {/* Graphiques et widgets
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-sm">
                    <h3 className="text-lg font-semibold text-emerald-800 mb-4">
                        Consommation Hebdomadaire
                    </h3>*/}
                    {/* Intégrez ici votre composant de graphique
                    <div className="h-[300px] bg-emerald-50 rounded-lg flex items-center justify-center">
                        <span className="text-emerald-600">Graphique de consommation</span>
                    </div>
                </div>

                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-sm">
                    <h3 className="text-lg font-semibold text-emerald-800 mb-4">
                        Appareils Actifs
                    </h3>*/}
                    {/* Liste des appareils
                    <div className="space-y-4">
                        <div className="flex items-center justify-between p-3 bg-emerald-50 rounded-lg">
                            <div className="flex items-center">
                                <span className="material-icons text-emerald-600 mr-3">ac_unit</span>
                                <div>
                                    <p className="font-medium text-emerald-800">Climatisation</p>
                                    <p className="text-sm text-emerald-600">23°C - Mode Éco</p>
                                </div>
                            </div>
                            <Switch defaultChecked className="text-emerald-600" />
                        </div>*/}
                        {/* Ajoutez d'autres appareils ici
                    </div>
                </div>
            </div>*/}            

            {/* Contenu de votre page Home */}
            <div className="p-1">

                <h3 className="text-lg font-semibold text-emerald-800 mb-4  ml-3">
                    Indicateurs sur les diagnostics de performance énergétique
                </h3>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-gray-600 text-sm">Total DPEs</Typography>
                                    <Typography variant="h4" className="font-bold text-gray-800">
                                        {stats?.totalDpe}
                                    </Typography>
                                </div>
                                <Assessment className="text-gray-400 text-3xl" />
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-green-600 text-sm">Classe A</Typography>
                                    <Typography variant="h4" className="font-bold text-green-800">
                                        {stats?.totalDpeA}
                                    </Typography>
                                </div>
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-100">
                                    <Typography className="text-green-600 text-2xl font-bold">A</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-lime-600 text-sm">Classe B</Typography>
                                    <Typography variant="h4" className="font-bold text-lime-800">
                                        {stats?.totalDpeB}
                                    </Typography>
                                </div>
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-lime-100">
                                    <Typography className="text-lime-600 text-2xl font-bold">B</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-yellow-600 text-sm">Classe C</Typography>
                                    <Typography variant="h4" className="font-bold text-yellow-800">
                                        {stats?.totalDpeC}
                                    </Typography>
                                </div>
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-yellow-100">
                                    <Typography className="text-yellow-600 text-2xl font-bold">C</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-orange-600 text-sm">Classe D</Typography>
                                    <Typography variant="h4" className="font-bold text-orange-800">
                                        {stats?.totalDpeD}
                                    </Typography>
                                </div>
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-orange-100">
                                    <Typography className="text-orange-600 text-2xl font-bold">D</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-red-500 text-sm">Classe E</Typography>
                                    <Typography variant="h4" className="font-bold text-red-700">
                                        {stats?.totalDpeE}
                                    </Typography>
                                </div>
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100">
                                    <Typography className="text-red-500 text-2xl font-bold">E</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-red-600 text-sm">Classe F</Typography>
                                    <Typography variant="h4" className="font-bold text-red-800">
                                        {stats?.totalDpeF}
                                    </Typography>
                                </div>
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100">
                                    <Typography className="text-red-600 text-2xl font-bold">F</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-red-600 text-sm">Classe G</Typography>
                                    <Typography variant="h4" className="font-bold text-red-800">
                                        {stats?.totalDpeG}
                                    </Typography>
                                </div>
                                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100">
                                    <Typography className="text-red-600 text-2xl font-bold">G</Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-gray-600 text-sm">Appartement</Typography>
                                    <Typography variant="h4" className="font-bold text-red-800">
                                        {stats?.totalDpeAppart}
                                    </Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2.4}>
                        <Card className="bg-white/80 backdrop-blur-sm p-4 h-full">
                            <Box className="flex items-center justify-between">
                                <div>
                                    <Typography className="text-gray-600 text-sm">Maison</Typography>
                                    <Typography variant="h4" className="font-bold text-red-800">
                                        {stats?.totalDpeHouse}
                                    </Typography>
                                </div>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Vos widgets et composants */}
            </div>




        </div>
    </MainLayout>
    );


};

export default Home;
